// Remembers the last non-billing/non-auth route the user was on, so a completed plan
// purchase (e.g. from the project page's credit-exhausted "Manage Plans" banner) can send
// them back there instead of always landing on the homepage. Populated by a location
// tracker mounted once in App.tsx, so it covers every entry point into /billing/plans
// without each caller having to thread the return path through router state.
const BILLING_RETURN_KEY = 'billing_return_to_v1';
const BILLING_RETURN_TTL_MS = 30 * 60 * 1000; // long enough to cover a slow card/3DS confirmation

const EXCLUDED_PATH_PREFIXES = ['/billing', '/login', '/signup', '/auth', '/forgot-password', '/reset-password'];

export const trackBillingReturnCandidate = (pathname: string, search: string): void => {
  if (typeof window === 'undefined') return;
  if (EXCLUDED_PATH_PREFIXES.some(prefix => pathname.startsWith(prefix))) return;
  try {
    sessionStorage.setItem(BILLING_RETURN_KEY, JSON.stringify({ path: pathname + search, ts: Date.now() }));
  } catch {
    // sessionStorage unavailable (e.g. private mode) — fall back to homepage on success
  }
};

export const consumeBillingReturnPath = (): string | null => {
  try {
    const raw = sessionStorage.getItem(BILLING_RETURN_KEY);
    if (!raw) return null;
    const { path, ts } = JSON.parse(raw) as { path: string; ts: number };
    if (Date.now() - ts > BILLING_RETURN_TTL_MS) return null;
    return path || null;
  } catch {
    return null;
  }
};
